import React, { useImperativeHandle, useMemo, useState } from 'react';
import { KTSVG } from '../../_metronic/helpers';
import styles from '../../constants/styles.module.css';
import AnalysisPopUp from 'lib/visx-lib/insights/analysisPopUp/AnalysisPopUp';
// import { useLocation } from 'react-router-dom';
import { MdAddChart } from 'react-icons/md';
import { FiFilter } from 'react-icons/fi';
import { RiLightbulbFill } from 'react-icons/ri';
import { allChartKeys } from 'lib/reusable-components/reusableData/chartTypesSchema';
import { defaultChartWidthTypesObj } from 'lib/reusable-components/reusableData/defaultChartSchema';
import { checkInsightsCapableChart } from 'lib/reusable-components/reusableFunction/chartBasicFuntions';
import { mls } from 'lib/multilanguagesupport';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';
import './layout.scss';
import { CircularProgress } from '@mui/material';
import { _supistaAnalyticsApi } from 'lib/server-connection/connections';
import { FaTimes } from 'react-icons/fa';
// async function fetchInsights(chartID, sheetID, appID) {
//   const res = await fetch(`https://analytics-api.supista.com/${appID}/insights`, {
//     method: 'POST',
//     body: JSON.stringify({
//       appID,
//       chartID,
//       sheetID,
//     }),
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//     },
//     credentials: 'include',
//   });
//   const data = await res.json();
//   return data;
// }

const Layout = ({
  title,
  chartData,
  isInsightChartSchema,
  isProd,
  chartSettingHandler,
  children,
  style,
  desc,
  isInsight = false,
  chartID,
  sheetID,
  appID,
  isPin,
  handlePin,
  isTopFilter,
  handleTopFilter,
  filterProps,
  insightRef,
  type,
  isInsightShow,
  cardWidth,
  tableID,
  isReport,
  timeFrameObj,
  filterObj,
  captureDivAsPng,
  exportDivLoading,
  isMenuButtonShow,
  isSmallChart,
  isFullScreenPopupChart,
  setIsFullScreenPopupChart,
  isCloseButtonShow,
  handleCloseButton,
}) => {
  return (
    <>
      {!isReport ? (
        <CardHeader
          isInsight={isInsight}
          chartData={chartData}
          isInsightChartSchema={isInsightChartSchema}
          isProd={isProd}
          title={title}
          chartSettingHandler={chartSettingHandler}
          desc={desc}
          chartID={chartID}
          sheetID={sheetID}
          appID={appID}
          isPin={isPin}
          handlePin={handlePin}
          isTopFilter={isTopFilter}
          handleTopFilter={handleTopFilter}
          filterProps={filterProps}
          insightRef={insightRef}
          type={type}
          isInsightShow={isInsightShow}
          cardWidth={cardWidth}
          tableID={tableID}
          timeFrameObj={timeFrameObj}
          filterObj={filterObj}
          chartName={title}
          captureDivAsPng={captureDivAsPng}
          exportDivLoading={exportDivLoading}
          isMenuButtonShow={isMenuButtonShow}
          isSmallChart={isSmallChart}
          isFullScreenPopupChart={isFullScreenPopupChart}
          setIsFullScreenPopupChart={setIsFullScreenPopupChart}
          isCloseButtonShow={isCloseButtonShow}
          handleCloseButton={handleCloseButton}
        />
      ) : null}
      <div style={style}>{children}</div>
    </>
  );
};

const CardHeader = ({
  isInsight,
  isInsightChartSchema,
  isProd,
  chartData,
  title,
  chartSettingHandler,
  desc,
  chartID,
  sheetID,
  appID,
  isPin,
  handlePin,
  filterProps,
  insightRef,
  type,
  isInsightShow,
  cardWidth,
  tableID,
  timeFrameObj,
  filterObj,
  chartName,
  captureDivAsPng,
  exportDivLoading,
  isMenuButtonShow,
  isSmallChart,
  isFullScreenPopupChart,
  setIsFullScreenPopupChart,
  isCloseButtonShow,
  handleCloseButton,
}) => {
  const checkForInsight = useMemo(() => {
    const isInsightCapable = checkInsightsCapableChart({ chartKey: chartData.chartType });
    if (isInsightCapable) {
      return isInsightShow;
    }
    return false;
  }, [isInsightShow, chartData.chartType]);
  const blankFunction = () => {};
  const isTopFilter = filterProps?.isTopFilter ?? false;
  const handleTopFilter = filterProps?.handleTopFilter ?? blankFunction;
  const filterCount = filterProps?.filterCount ?? 0;

  const [isAnaysisPopup, setIsAnaysisPopup] = useState(false);
  const [isAnaysisLoading, setIsAnaysisLoading] = useState(false);
  const handleMainPopUp = (action) => {
    setIsAnaysisPopup(action);
  };
  const [insightData, setData] = useState({});
  const handleClick = async (e) => {
    e?.preventDefault();
    setIsAnaysisPopup(true);
    setIsAnaysisLoading(true);
    if (!insightData.chartType) {
      const normalInsightsData = {
        chartID,
        sheetID,
        appID,
        tableID,
        timeFrame: timeFrameObj,
        filters: filterObj,
      };

      const insightsDataWithChartSchema = {
        chartID,
        sheetID,
        appID,
        tableID,
        timeFrame: timeFrameObj,
        filters: filterObj,
        chartSchema: { [chartData?.chartID]: chartData },
      };
      const body = isInsightChartSchema ? insightsDataWithChartSchema : normalInsightsData;
      const payload = `${appID}/insights`;
      const data = await _supistaAnalyticsApi(payload, body);
      if (!data.__d3__error) {
        setData(data.response);
      }
    }
    setIsAnaysisLoading(false);
  };

  useImperativeHandle(insightRef, () => ({
    openInsight() {
      handleClick();
    },
  }));
  const isCardStyle = () => {
    if (type === allChartKeys.CARD) {
      return true;
    }
    if (type === allChartKeys.KPIMETER) {
      if (cardWidth === defaultChartWidthTypesObj.ONEFOURTH.key) {
        return true;
      }
    }
    return false;
  };
  const optionObject = {
    settings: {
      key: 'settings',
      name: 'Settings',
    },
    exportPng: {
      key: 'exportPng',
      name: 'Export Chart',
    },
    fullscreen: {
      key: 'fullscreen',
      name: 'Full Screen View',
    },
  };
  const getFinalOption = () => {
    let finalOption = { exportPng: optionObject.exportPng };
    if (isProd === 'sheet') {
      finalOption = { settings: optionObject.settings, exportPng: optionObject.exportPng };
    }
    if (isSmallChart) {
      finalOption = { ...finalOption, fullscreen: optionObject.fullscreen };
    }
    return finalOption;
  };
  const finalOption = getFinalOption();
  const handleOptionDropdown = (action) => {
    if (action === optionObject.settings.key) {
      chartSettingHandler();
    }
    if (action === optionObject.exportPng.key) {
      captureDivAsPng();
    }
    if (action === optionObject.fullscreen.key) {
      setIsFullScreenPopupChart(true);
    }
  };
  return (
    <div className='card-header border-0 p-0 pb-2'>
      <div className={`${styles.titleDiv} w-100 d-flex justify-content-between align-items-center`}>
        {/* Append Title of the chart */}
        <h4
          className='mb-0'
          style={
            isCardStyle()
              ? {
                  width: '100%',
                  display: '-webkit-box',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }
              : { wordWrap: 'break-word', width: '100%' }
          }
          title={mls(title)}
        >
          {mls(title)}
        </h4>
        <div>
          {checkForInsight && isInsight && (
            <div className='card-toolbar heightFix'>
              {/* begin::Menu */}
              <button
                type='button'
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                onClick={handleClick}
                style={{
                  height: `calc(1em + (1.1rem + 2px))`,
                  width: ` calc(1em + (1.1rem + 2px))`,
                }}
              >
                {/* <TipsAndUpdatesIcon /> */}
                <RiLightbulbFill style={{ fontSize: '1.25rem' }} />
              </button>
              {/* end::Menu */}
            </div>
          )}
          {isTopFilter && (
            <div className='card-toolbar heightFix'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                onClick={handleTopFilter}
                style={{
                  height: `calc(1em + (1.1rem + 2px))`,
                  width: ` calc(1em + (1.1rem + 2px))`,
                  position: 'relative',
                }}
              >
                <FiFilter style={{ fontSize: '1.5rem' }} />
                <div
                  className='displayFilter'
                  style={{
                    position: 'absolute',
                    top: '4px',
                    right: '2px',
                    height: '1rem',
                    width: '1rem',
                    background: '#009df6',
                    fontSize: '.6rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    borderRadius: '6px',
                    fontWeight: 500,
                    color: 'white',
                  }}
                >
                  {filterCount}
                </div>
              </button>
            </div>
          )}
          {isPin && (
            <div className='card-toolbar heightFix'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                onClick={handlePin}
                style={{
                  height: `calc(1em + (1.1rem + 2px))`,
                  width: ` calc(1em + (1.1rem + 2px))`,
                }}
              >
                <MdAddChart style={{ fontSize: '1.25rem' }} />
              </button>
            </div>
          )}

          {/* {isProd === 'sheet' && (
            <div className='card-toolbar heightFix'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                onClick={chartSettingHandler}
              >
                <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
              </button>
            </div>
          )} */}
          {isMenuButtonShow ? (
            <div className='card-toolbar heightFix'>
              {exportDivLoading ? (
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                  style={{
                    height: `calc(1em + (1.1rem + 2px))`,
                    width: ` calc(1em + (1.1rem + 2px))`,
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress size={15} />
                  </div>
                </button>
              ) : (
                <ObjectDropDown
                  object={finalOption}
                  dropDownValue={''}
                  setdropDownValue={handleOptionDropdown}
                  ObjectInObject
                  isChildernInsert
                  className='layoutOptionDropdown'
                  isDropDownFixed={false}
                >
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                    style={{
                      height: `calc(1em + (1.1rem + 2px))`,
                      width: ` calc(1em + (1.1rem + 2px))`,
                    }}
                  >
                    <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
                  </button>
                </ObjectDropDown>
              )}
            </div>
          ) : null}
          {isCloseButtonShow && (
            <div className='card-toolbar heightFix'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-light-danger closeButtonColor'
                onClick={() => handleCloseButton(false)}
                style={{
                  height: `calc(1em + (1.1rem + 2px))`,
                  width: ` calc(1em + (1.1rem + 2px))`,
                }}
              >
                <FaTimes style={{ fontSize: '1.25rem' }} />
              </button>
            </div>
          )}
        </div>
      </div>
      {isCardStyle() ? (
        <p
          className='mb-0'
          style={{
            width: '100%',
            display: '-webkit-box',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#6E7191',
            minHeight: '1.5rem',
          }}
          title={desc}
        >
          {desc}
        </p>
      ) : (
        desc && (
          <p className='mb-0' style={{ color: '#6E7191', width: '100%' }} title={desc}>
            {desc}
          </p>
        )
      )}
      {/* {desc && (
        <p
          className='mb-0'
          style={
            type === 'CARD'
              ? {
                  width: '100%',
                  display: '-webkit-box',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: '#6E7191',
                  height: '3rem',
                }
              : { color: '#6E7191', width: '100%' }
          }
        >
          {desc}
        </p>
      )} */}
      {isAnaysisPopup && (
        <AnalysisPopUp
          chartData={chartData}
          mainData={insightData}
          isAnaysisLoading={isAnaysisLoading}
          handleMainPopUp={handleMainPopUp}
          mainPopUp={isAnaysisPopup}
          chartName={chartName}
        />
      )}
    </div>
  );
};

export default Layout;
